import { Breadcrumbs, Typography, Link, Box, Tab, Tabs } from "@mui/material";
import { useCargosCadastroViewModel } from "../../viewModels/cargos_cadastro_view_model";
import { BackButton } from "../../../../../common/components/back_button";
import { TabInformacoesGerais } from "./components/tab_informacoes_gerais";
import { TabTreinamentos } from "./components/tab_treinamentos";
import { TabHabilidades } from "./components/tab_habilidades";
import { isValidId } from "../../../../../common/utils/utils";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { Link as LinkTo } from 'react-router';
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";

import RefreshButton from "../../../../../common/components/refresh_button";
import AlertError from "../../../../../common/components/alert_error";
import BottomBar from "../../../../../common/components/bottom_bar";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";

/**
 * CargosCadastro
 */

export const CargosCadastro = () => {
  const viewModel = useCargosCadastroViewModel();
  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          leftSlot={
            <div className="w-full flex flex-row gap-2">
              {viewModel.selectedCargo && (
                <div className="w-full h-full flex flex-col justify-center text-black dark:text-white">
                  <span className="font-bold text-md">{viewModel.selectedCargo.descricao}</span>
                </div>
              )}
            </div>
          }
          rightSlot={
            <BackButton
              onClick={viewModel.handleBack}
            />
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <form className="pb-8" onSubmit={viewModel.handleSubmit}>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              RH
            </Link>
            <Link underline="hover" color="inherit" component={'span'}>
              <LinkTo to='/Cargos_lista'>Funcionários</LinkTo>
            </Link>
            <Typography className="text-primary-green">
              Cadastro de Cargos
            </Typography>
          </Breadcrumbs>

          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Cadastro de Cargo</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>

            <div className="w-full justify-end flex gap-2"></div>
          </div>
          {
            viewModel.errorMessage !== undefined
              ? (
                <div className="w-full">
                  <AlertError
                    messageErro={viewModel.errorMessage}
                    onTryAgain={viewModel.handleReload} />
                </div>
              ) : (
                <div className="relative bg-transparent">
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                      variant="scrollable"
                      scrollButtons="auto"
                      slotProps={{
                        startScrollButtonIcon: {
                          className: "text-black dark:text-white",
                        },
                        endScrollButtonIcon: {
                          className: "text-black dark:text-white",
                        },
                        indicator: {
                          style: {
                            background: '#009C4E',
                          }
                        }
                      }}
                      value={viewModel.currentTab}
                      onChange={viewModel.handleTabChange}>
                      <Tab
                        sx={{
                          textTransform: "none",
                          '&.Mui-selected': {
                            color: '#009C4E',
                          },
                        }}
                        label="Informações Gerais"
                        value={1} />

                      <Tab
                        sx={{
                          textTransform: "none",
                          '&.Mui-selected': {
                            color: '#009C4E',
                          },
                        }}
                        label="Treinamentos"
                        value={2} />

                      <Tab
                        sx={{
                          textTransform: "none",
                          '&.Mui-selected': {
                            color: '#009C4E',
                          },
                        }}
                        label="Habilidades"
                        value={3} />

                    </Tabs>
                  </Box>
                  <div className="py-6 text-black dark:text-white">
                    {
                      viewModel.currentTab === 1 &&
                      <TabInformacoesGerais
                        saving={viewModel.saving}
                        reactHookForm={viewModel.hookForm}
                      />
                    }
                    {
                      viewModel.currentTab === 2 &&
                      <TabTreinamentos
                        loading={viewModel.loading}
                        saving={viewModel.saving}
                        gridRowSelectionModel={viewModel.treinamentosSelectionModel ?? { type: 'include', ids: new Set() }}
                        cargoTreinamentos={viewModel.cargoTreinamentos ?? []}
                        page={viewModel.pagination.treinamentos.page}
                        rowsPerPage={viewModel.pagination.treinamentos.rowsPerPage}
                        totalItems={viewModel.pagination.treinamentos.totalItems}
                        onPageChange={viewModel.handleCargoTreinamentosPageChange}
                        onRowsPerPageChange={viewModel.handleCargoTreinamentosRowsPerPageChange}
                        onSelectionModelChange={viewModel.handleTreinamentosSelectionModelChange}
                      />
                    }
                    {
                      viewModel.currentTab === 3 &&
                      <TabHabilidades
                        loading={viewModel.loading}
                        saving={viewModel.saving}
                        gridRowSelectionModel={viewModel.habilidadesSelectionModel ?? { type: 'include', ids: new Set() }}
                        cargoHabilidades={viewModel.cargoHabilidades ?? []}
                        page={viewModel.pagination.habilidades.page}
                        rowsPerPage={viewModel.pagination.habilidades.rowsPerPage}
                        totalItems={viewModel.pagination.habilidades.totalItems}
                        onPageChange={viewModel.handleCargoHabilidadesPageChange}
                        onRowsPerPageChange={viewModel.handleCargoHabilidadesRowsPerPageChange}
                        onSelectionModelChange={viewModel.handlehabilidadesSelectionModelChange}
                      />
                    }
                  </div>
                </div>
              )
          }
        </div>

        {/**
          * Bottom bar
          */}

        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4">
            <div>
              {
                isValidId(viewModel.selectedIdCargo) &&
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory(null, null)}>
                  <span className="text-xs">
                    Historico de alterações
                  </span>
                </PrimaryButton>
              }
            </div>

            <div className="flex flex-row gap-4">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={viewModel.handleBack}>
                  Cancelar
                </h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving
                  ? (
                    <PrimaryButton>
                      Salvando...
                    </PrimaryButton>
                  ) : (
                    <PrimaryButton
                      type="submit"
                      startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                      Salvar
                    </PrimaryButton>
                  )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form >

      {/**
        * Modal historico de alterações.
        */}

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory} />
    </>
  );
}